import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { restoreAccessWaitingArea } from '../../../../actions/waitingArea';
import { Icon, Container, Message } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

function handleLineBreakInText(text) {
  return text.split('\n').map((item, i) => (
    <div key={i}>
      {item}
      <br />
    </div>
  ));
}

export function SuspendMessageForManage(props) {
  const dispatch = useDispatch();
  return (
    <div className="color-right-hand-side-panel-bg max-width pdlnull pdrnull">
      <div className="row flexible row-hoverable  center-text pointer color-right-hand-side-panel-bg pdlm pdrm">
        <Message icon className="borderless bg-transparent mrbnull pdlnull pdrnull pdts pdbs">
          <Message.Content>
            <div className="inline-flex center-flex">
              <Icon name="pause circle" size="big" className="waiting-area-red" style={{ marginRight: '10px' }} />
              <div className="text-size-m left-text">
                {htmlToReactParser.parse(xss(APP.LANGUAGE.ViewOneWaitingArea.AccessSuspendedPartOne))}
              </div>
            </div>
          </Message.Content>
        </Message>
        <Container fluid as={Media} greaterThanOrEqual="tablet" style={{ position: 'absolute', marginTop: '10px' }}>
          <div
            onClick={() => dispatch(restoreAccessWaitingArea(props.waitingArea))}
            className="ui button fr waiting-area-green-bg color-white pdlm pdrm mrrnull"
            style={{ fontSize: '0.88rem' }}
          >
            {APP.LANGUAGE.ViewOneWaitingArea.RestoreAccess}
          </div>
        </Container>
        <Container fluid as={Media} at="mobile" className="max-width">
          <div
            onClick={() => dispatch(restoreAccessWaitingArea(props.waitingArea))}
            className="ui button waiting-area-green-bg color-white mrlm mrrm mrbs"
          >
            {APP.LANGUAGE.ViewOneWaitingArea.RestoreAccess}
          </div>
        </Container>
      </div>
      <div className="row flexible row-hoverable center-text pointer color-right-hand-side-panel-bg pdlm pdrm">
        {props.waitingArea.suspendedMessageProvider && props.waitingArea.suspendedMessageProvider != '' ? (
          <div className="column max-width text-size-m center-text">
            {handleLineBreakInText(props.waitingArea.suspendedMessageProvider)}
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export function SuspendMessageForView(props) {
  return (
    <div className="color-right-hand-side-panel-bg max-width pdlnull pdrnull">
      <div className="row flexible row-hoverable center-text pointer color-right-hand-side-panel-bg">
        <Message icon className="borderless bg-transparent mrbnull pdlnull pdrnull pdts pdbs">
          <Message.Content>
            <div className="inline-flex center-flex">
              <Icon name="pause circle" size="big" className="waiting-area-red" style={{ marginRight: '10px' }} />
              <div className="text-size-m left-text">
                {htmlToReactParser.parse(xss(APP.LANGUAGE.ViewOneWaitingArea.AccessSuspendedPartOne))}
              </div>
            </div>
          </Message.Content>
        </Message>
      </div>
      <div className="row flexible row-hoverable center-text pointer color-right-hand-side-panel-bg pdlm pdrm">
        {props.waitingArea.suspendedMessageProvider && props.waitingArea.suspendedMessageProvider != '' ? (
          <div className="column max-width text-size-m center-text">
            {handleLineBreakInText(props.waitingArea.suspendedMessageProvider)}
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
